/**
 * Shared constants and types for the SCM authorization popup flow.
 *
 * These live apart from `use-scm-authorization-popup.hook.ts` so that consumers
 * which only need the constants/type (e.g. the callback handler component) don't
 * transitively import the hook's Apollo dependency — importing that hook into a
 * test's module graph otherwise binds its generated-hook mock and corrupts the
 * hook's own test when they share a worker.
 */
export const SCM_AUTH_SESSION_KEY = 'scm-auth-pending';
export const DEFAULT_CALLBACK_PARAMETERS = ['code', 'state'];

export type PendingAuthData = {
  authorizationId: string;
  callbackParameters: string[];
};
